import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import { useAuth } from '../contexts/AuthContext';
import { changePassword } from '../api/franchise.api';
import styles from './SettingsPage.module.css';

export default function AccountSettingsPage() {
  const { franchiseId } = useAuth();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pwLoading, setPwLoading] = useState(false);
  const [pwMessage, setPwMessage] = useState<{ type: 'ok' | 'err'; text: string } | null>(null);

  async function handleChangePassword(e: React.FormEvent) {
    e.preventDefault();
    setPwMessage(null);

    if (!franchiseId) return;
    if (newPassword.length < 8) {
      setPwMessage({ type: 'err', text: '새 비밀번호는 8자 이상이어야 합니다.' });
      return;
    }
    if (newPassword !== confirmPassword) {
      setPwMessage({ type: 'err', text: '새 비밀번호 확인이 일치하지 않습니다.' });
      return;
    }

    setPwLoading(true);
    try {
      await changePassword(franchiseId, currentPassword, newPassword);
      setPwMessage({ type: 'ok', text: '비밀번호가 변경되었습니다.' });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err: any) {
      setPwMessage({
        type: 'err',
        text: err?.response?.data?.message || err?.message || '비밀번호 변경에 실패했습니다.',
      });
    } finally {
      setPwLoading(false);
    }
  }

  return (
    <Layout>
      <div className={styles.page}>
        <h1 className={styles.title}>계정 설정</h1>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>비밀번호 변경</h2>
          <form className={styles.form} onSubmit={handleChangePassword}>
            <div className={styles.field}>
              <label className={styles.label}>현재 비밀번호</label>
              <input
                type="password"
                className={styles.input}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>새 비밀번호</label>
              <input
                type="password"
                className={styles.input}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
                placeholder="8자 이상"
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>새 비밀번호 확인</label>
              <input
                type="password"
                className={styles.input}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>

            {pwMessage && (
              <div className={pwMessage.type === 'ok' ? styles.messageOk : styles.messageErr}>
                {pwMessage.text}
              </div>
            )}

            <button type="submit" className={styles.submitBtn} disabled={pwLoading}>
              {pwLoading ? '변경 중...' : '비밀번호 변경'}
            </button>
          </form>
        </section>
      </div>
    </Layout>
  );
}
